import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';

configure({ enforceActions: 'always' });

class UrlStore extends StoreModel {
    constructor() {
        super('url', {
            namePlural: 'urls',
            sort: 'clicks',
            api: {
                search: {
                    url: '/api/shorturls/',
                    params: {},
                },
                load: {
                    url: '/api/shorturls/',
                    params: {},
                },
                save: {
                    url: '/api/shorturls/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable url = {};

    @observable urls = [];
}

const store = new UrlStore();
export default store;



// WEBPACK FOOTER //
// ./stores/url.js